import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "measurement-overview" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "measurement-overview__section" }
const _hoisted_6 = { class: "measurement-overview__row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "measurement-overview__row" }
const _hoisted_10 = { class: "measurement-overview__difference" }
const _hoisted_11 = { class: "measurement-overview__row" }
const _hoisted_12 = { class: "measurement-overview__difference" }
const _hoisted_13 = { class: "measurement-overview__section" }
const _hoisted_14 = { class: "measurement-overview__row" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "measurement-overview__row" }
const _hoisted_18 = { class: "measurement-overview__difference" }
const _hoisted_19 = { class: "measurement-overview__row" }
const _hoisted_20 = { class: "measurement-overview__difference" }
const _hoisted_21 = { class: "measurement-overview__section" }
const _hoisted_22 = { class: "measurement-overview__row" }
const _hoisted_23 = {
  key: 0,
  class: "measurement-overview__size-x"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "measurement-overview__section" }
const _hoisted_26 = { class: "measurement-overview__row" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 0,
  class: "measurement-overview__size-y"
}

import { computed } from 'vue'
import { useMeasurementStore } from '@/store/measurementStore'
import { storeToRefs } from 'pinia'
import { ButtonState, BfButton } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'MeasurementOverview',
  setup(__props) {

const { t } = useI18n()
const measurementStore = useMeasurementStore()
const { measurements, firstMeasurement } = storeToRefs(measurementStore)

const measurementsList = computed(() => {
  if (measurements.value.length <= 1) {
    return measurements.value
  }

  return measurements.value.slice(0, -1)
})

const deleteMeasurement = (index: number) => {
  measurementStore.delete(index)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(measurementsList.value, (measurement, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: _normalizeClass([
        'measurement-overview__item',
        {
          'measurement-overview__item--favorite': i === _unref(measurements).length - 2,
        },
      ])
      }, [
        (i === 0)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_unref(t)('measurement.start')), 1))
          : _createCommentVNode("", true),
        (_unref(measurements).length > 1 && i === _unref(measurements).length - 2)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(t)('measurement.final')), 1))
          : _createCommentVNode("", true),
        (
          i <= _unref(measurements).length - 2 &&
          i !== 0 &&
          i !== _unref(measurements).length - 2
        )
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(`#${i}`), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.saddle')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("strong", null, [
              (measurement.saddle.active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(measurement.saddle.active.SADDLE_BRAND) + " " + _toDisplayString(measurement.saddle.active.SADDLE_MODEL), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('common.position.x')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(`${measurement.saddle.x} ${_unref(t)('common.unit.mm')}`) + " ", 1),
              _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(`${measurement.saddle.x - _unref(firstMeasurement).saddle.x} ${_unref(t)('common.unit.mm')}`) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('common.position.y')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(`${measurement.saddle.y} ${_unref(t)('common.unit.mm')}`) + " ", 1),
              _createElementVNode("span", _hoisted_12, "(" + _toDisplayString(`${measurement.saddle.y - _unref(firstMeasurement).saddle.y} ${_unref(t)('common.unit.mm')}`) + ")", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.handlebar')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("strong", null, [
              (measurement.handlebar.active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(measurement.handlebar.active.HANDLEBAR_BRAND) + " " + _toDisplayString(measurement.handlebar.active.HANDLEBAR_MODEL), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('common.position.x')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(`${measurement.handlebar.x * -1} ${_unref(t)('common.unit.mm')}`) + " ", 1),
              _createElementVNode("span", _hoisted_18, "(" + _toDisplayString(`${(measurement.handlebar.x - _unref(firstMeasurement).handlebar.x) * -1} ${_unref(t)('common.unit.mm')}`) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)('common.position.y')), 1),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(`${measurement.handlebar.y} ${_unref(t)('common.unit.mm')}`) + " ", 1),
              _createElementVNode("span", _hoisted_20, "(" + _toDisplayString(`${measurement.handlebar.y - _unref(firstMeasurement).handlebar.y} ${_unref(t)('common.unit.mm')}`) + ")", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.crankset')), 1),
          _createElementVNode("div", _hoisted_22, [
            (measurement.crankset.active)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(measurement.crankset.active) + " " + _toDisplayString(_unref(t)('common.unit.mm')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_24, "-"))
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.pedals')), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("strong", null, [
              (measurement.pedal.active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(measurement.pedal.active.PEDAL_BRAND) + " " + _toDisplayString(measurement.pedal.active.PEDAL_MODEL), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, "-"))
            ]),
            (measurement.pedal.active?.PEDAL_HEIGHT)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(measurement.pedal.active?.PEDAL_HEIGHT) + " " + _toDisplayString(_unref(t)('common.unit.mm')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_unref(BfButton), {
          state: i === 0 ? _unref(ButtonState).Disabled : _unref(ButtonState).Enabled,
          onClick: ($event: any) => (deleteMeasurement(i))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.delete')), 1)
          ]),
          _: 1
        }, 8, ["state", "onClick"])
      ], 2))
    }), 128))
  ]))
}
}

})